import { ProgressBarInfo } from '@apply/components';
import type { StandardLoanState } from '../../../../../state/standardLoanState';
import { getSetupProgress } from '../Setup/functions/getSetupProgress';
import { getBorrowerProgress } from '../Borrower/functions/getBorrowerProgress';
import { isBorrowerLocked } from '../Borrower/functions/isBorrowerLocked';

/** Completion for the whole Setup & Borrower step: the Setup and Borrower sections' required fields together. */
export const getSetupAndBorrowerProgress = (
    state: Pick<StandardLoanState, 'setup' | 'setupLoanContext' | 'selectedTermKey' | 'borrower' | 'borrowerLoanContext'>
): ProgressBarInfo => {
    const setupProgress = getSetupProgress(state.setup, state.setupLoanContext, state.selectedTermKey);
    const borrowerProgress = getBorrowerProgress(
        state.borrower,
        isBorrowerLocked(state.setupLoanContext.isSubNote, state.borrowerLoanContext)
    );
    return {
        numberComplete: setupProgress.numberComplete + borrowerProgress.numberComplete,
        total: setupProgress.total + borrowerProgress.total,
    };
};
